import { useApi } from './use-api-call';


export const useSearchSmsTypeApi = () => useApi<{ 
smsTypes: SmsTypeDTO[];
        allowEdit: boolean; 
    }>('/sms-type/search-sms-type');

export const useGetSmsTypeApi = () => useApi<{ smsType: SmsTypeDTO; allowEdit: boolean; }>('/sms-type/get-sms-type/{id}');

export const useSaveSmsTypeApi = () => useApi<{ smsType: SmsTypeDTO}>('/sms-type/save-sms-type');

export const useDeleteSmsTypeApi = () => useApi('/sms-type/delete-sms-type/{id}');

export interface SmsTypeDTO { 
id:string;
title:string;
}
